import React, { useEffect, useState } from "react";

const WHATSAPP_LINK = "https://chat.whatsapp.com/I0al23LIggxIQ4PO7MAdvt";

export const WhatsAppFloat = () => {
  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTopBtn(window.scrollY > 300);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!showTopBtn) return null;

  return (
    <>
      <style>{`
        @keyframes waFloat {
          0%,100% { transform: translateY(0px); }
          50%      { transform: translateY(-7px); }
        }
        .wa-float-link { animation: waFloat 3.5s ease-in-out infinite; display: inline-block; }
        .wa-float-link:hover { animation-play-state: paused; }
        .wa-float-link svg { width: 80px; height: 80px; }
        @media (min-width: 768px) {
          .wa-float-link svg { width: 120px; height: 120px; }
        }
      `}</style>

      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="wa-float-link"
        style={{
          position: "fixed",
          bottom: 16,
          right: 22,
          zIndex: 1000,
          textDecoration: "none",
        }}
      >
        <svg width="132" height="132" viewBox="0 0 132 132">
          <defs>
            <path
              id="waTextPath"
              d="M 63,70 m -58,0 a 58,58 0 1,1 118,0 a 58,48 0 1,1 -116,0"
            />

            <filter id="waGlow" x="-40%" y="-40%" width="180%" height="180%">
              <feDropShadow dx="0" dy="4" stdDeviation="7" floodColor="#25D366" floodOpacity="0.55" />
            </filter>

            <filter id="waTextShadow" x="-40%" y="-40%" width="180%" height="180%">
              <feMorphology operator="dilate" radius="0.5" in="SourceAlpha" result="expand" />
              <feFlood floodColor="#000000" floodOpacity="1" result="color" />
              <feComposite in="color" in2="expand" operator="in" result="outline" />
              <feMerge>
                <feMergeNode in="outline" />
                <feMergeNode in="outline" />
                <feMergeNode in="outline" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>

          <circle cx="65" cy="65" r="40" fill="#25D366" filter="url(#waGlow)" />

          <svg x="52" y="52" width="26" height="26" viewBox="0 0 24 24">
            <path
              fill="white"
              d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"
            />
          </svg>

          <text
            fill="white"
            fontSize="14"
            fontFamily="Abel, sans-serif"
            letterSpacing="1.2"
            fontWeight="900"
            filter="url(#waTextShadow)"
          >
            <textPath href="#waTextPath" startOffset="4%">
              ✦ Join Believers Class ✦
            </textPath>
          </text>
        </svg>
      </a>
    </>
  );
};
